// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4356d1e5","703":"116bc298"}[chunkId] + ".chunk.js";
};